(function (window, document) {
  'use strict';

  var selector = [
    '[data-animate="pop"]',
    '[data-animate="fade-up"]',
    '[data-animate="fade"]',
    '[data-animate="scale"]',
  ].join(',');

  if (window.StoreReveal && typeof window.StoreReveal.refresh === 'function') {
    window.StoreReveal.refresh(document);
    return;
  }

  var defaultStagger = 80;
  var defaultThreshold = 0.2;
  var defaultRootMargin = '0px 0px -10% 0px';
  var reducedMotion =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var wiredElements = new WeakSet();
  var observer = null;

  document.documentElement.classList.add('store-reveal-ready');

  function elementsWithin(root) {
    var elements = [];
    if (root instanceof Element && root.matches(selector)) elements.push(root);
    if (root && typeof root.querySelectorAll === 'function') {
      elements = elements.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
    }
    return elements;
  }

  function numberAttribute(element, name, fallback) {
    var value = element.getAttribute(name);
    if (value === null || value === '') return fallback;
    var number = parseFloat(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function show(element) {
    if (reducedMotion) {
      element.style.willChange = 'auto';
    } else {
      element.style.willChange = 'transform, opacity';
      element.addEventListener(
        'transitionend',
        function () {
          element.style.willChange = 'auto';
        },
        { once: true }
      );
    }
    element.classList.add('is-animated');
    element.dispatchEvent(new CustomEvent('store-reveal:shown', { bubbles: true }));
  }

  function handleIntersections(entries) {
    entries.forEach(function (entry) {
      var element = entry.target;
      var repeats = element.getAttribute('data-animate-repeat') === 'true';
      if (entry.isIntersecting) {
        show(element);
        if (!repeats && observer) observer.unobserve(element);
      } else if (repeats) {
        element.classList.remove('is-animated');
      }
    });
  }

  function getObserver() {
    if (observer || !('IntersectionObserver' in window)) return observer;
    observer = new IntersectionObserver(handleIntersections, {
      threshold: defaultThreshold,
      rootMargin: defaultRootMargin,
    });
    return observer;
  }

  function configure(element, index, stagger) {
    var rotate = numberAttribute(element, 'data-animate-rotate', null);
    var rotateFrom = numberAttribute(element, 'data-animate-rotate-from', null);
    var duration = numberAttribute(element, 'data-animate-duration', null);
    var explicitDelay = numberAttribute(element, 'data-animate-delay', null);
    var delay = explicitDelay === null ? index * stagger : explicitDelay;

    if (rotate !== null) {
      element.style.setProperty('--store-reveal-rotate', rotate + 'deg');
      if (rotateFrom === null) rotateFrom = rotate * 1.6;
    }
    if (rotateFrom !== null) {
      element.style.setProperty('--store-reveal-rotate-from', rotateFrom + 'deg');
    }
    if (duration !== null) {
      element.style.setProperty('--store-reveal-duration', Math.max(0, duration) + 'ms');
    }
    element.style.setProperty('--store-reveal-delay', Math.max(0, delay) + 'ms');
    element.style.transitionDelay = 'var(--store-reveal-delay)';
  }

  function grouped(elements) {
    var groups = new Map();
    var soloIndex = 0;
    elements.forEach(function (element) {
      var key = element.getAttribute('data-animate-group') || '__solo_' + soloIndex++;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(element);
    });
    return groups;
  }

  function scan(root) {
    var elements = elementsWithin(root || document);
    var loadQueue = [];

    grouped(elements).forEach(function (members) {
      var stagger = defaultStagger;
      members.some(function (element) {
        var configuredStagger = numberAttribute(element, 'data-animate-stagger', null);
        if (configuredStagger === null) return false;
        stagger = Math.max(0, configuredStagger);
        return true;
      });

      members.forEach(function (element, index) {
        if (wiredElements.has(element)) return;
        wiredElements.add(element);
        configure(element, index, stagger);

        if (reducedMotion) {
          show(element);
          return;
        }

        var trigger = element.getAttribute('data-animate-on') || 'scroll';
        if (trigger === 'load') {
          loadQueue.push(element);
          return;
        }

        var intersectionObserver = getObserver();
        if (intersectionObserver) {
          intersectionObserver.observe(element);
        } else {
          show(element);
        }
      });
    });

    if (loadQueue.length) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          loadQueue.forEach(show);
        });
      });
    }
  }

  function replay(root) {
    var elements = elementsWithin(root || document);
    elements.forEach(function (element) {
      element.style.willChange = 'transform, opacity';
      element.style.transition = 'none';
      element.classList.remove('is-animated');
      void element.offsetWidth;
    });
    if (reducedMotion) {
      elements.forEach(function (element) {
        element.style.removeProperty('transition');
      });
      elements.forEach(show);
      return;
    }
    requestAnimationFrame(function () {
      elements.forEach(function (element) {
        element.style.removeProperty('transition');
      });
      requestAnimationFrame(function () {
        elements.forEach(show);
      });
    });
  }

  function init() {
    scan(document);
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var control = event.target.closest('[data-store-reveal-replay]');
    if (!control) return;
    var targetId = control.getAttribute('aria-controls');
    var target = targetId ? document.getElementById(targetId) : control.closest('[data-store-reveal-demo]');
    if (target) replay(target);
  });

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target || document);
  });

  document.addEventListener('theme:dynamic-content', function (event) {
    var scope = event.detail && event.detail.scope ? event.detail.scope : document;
    scan(scope);
  });

  window.StoreReveal = {
    init: init,
    refresh: scan,
    replay: replay,
    version: '1.0.0',
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})(window, document);
